import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustRowProps {
  dark?: boolean;
}
export function TrustRow({
  dark = false
}: TrustRowProps) {
  return <div className={`flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-5 text-[11px] sm:text-sm font-semibold ${dark ? 'text-cream/90' : 'text-warmgray'}`} data-id="element-143" data-mp="22xqp6ek7gxby">
      <span className="flex items-center gap-1.5" data-id="element-144" data-mp="2crhaxboy6tny">
        <span className="text-gold tracking-tighter" aria-hidden="true" data-id="element-145" data-mp="1oz0kacr59td1">
          ⭐⭐⭐⭐⭐
        </span>
        <span data-id="element-146" data-mp="1k1sap0k2axne">4.9/5 — Recensioni Verificate dagli Allenatori</span>
      </span>
      <span className="flex items-center gap-1.5" data-id="element-147" data-mp="1yyj0ci3xouzt">
        <ShieldCheckIcon className="w-4 h-4 text-sage shrink-0" data-id="element-148" data-mp="1yzay9zl074t9" />
        <span data-id="element-149" data-mp="1txv9pxjmag64">Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi</span>
      </span>
    </div>;
}